import { render, staticRenderFns } from "./formManufacturer.vue?vue&type=template&id=3a842470&scoped=true&"
import script from "./formManufacturer.vue?vue&type=script&lang=js&"
export * from "./formManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a842470",
  null
  
)

export default component.exports